export {
  generateCorrelationIds,
  type CorrelationIds,
  type CorrelationIdSeeds,
} from './correlationIds';

export {
  buildCustomDimensions,
  type CustomDimension,
} from './customDimensions';

export {
  resolveActionOutcome,
  resolveActionOutcomeForStep,
  resolveActionOutcomeForBranch,
  ACTION_OUTCOME_QUESTION,
  ACTION_OUTCOME_RESULTS,
  type ActionOutcome,
} from './actionOutcome';

export {
  buildEventContext,
  DEFAULT_FORM_NAME,
  type DynamicExperienceEventContext,
} from './buildEventContext';

export { getExperienceVariant } from './getExperienceVariant';

export {
  useDynamicExperienceEventing,
  type UseDynamicExperienceEventingParams,
  type UseDynamicExperienceEventingResult,
} from './useDynamicExperienceEventing';

export {
  buildStepCorrelation,
  DEFAULT_STEP_PAGE_CATEGORY,
  type StepCorrelation,
  type BuildStepCorrelationParams,
} from './stepCorrelation';
